export default __webpack_public_path__ + "static/media/chevron_right.c57a27b5.svg";